// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* upperLayercontainer */

.about_mainContainer__Zl7h9{
    display: flex;
    flex-direction: row;
    padding-top: 7em;
    gap: 1em;
    margin: auto 6em;
}

.about_leftChildContainer__bbIKG{
    flex: 1 1;
}

.about_topleftcontainer__0PP1l{
    display: flex;
    flex-direction: row;
}

.about_topleftcontainer__0PP1l h3{
    font-size: 1.3em;
    margin-left: 1em;
}

.about_rightChildContainer__sNO70{
    flex: 1 1;
}

.about_linkStyle__cxNkj{
    text-decoration: none;
    color: black;
    font-size: 1.3em;
}

.about_linkStyle__cxNkj:hover{
    color: aqua;
}

.about_rightChildContainer__sNO70 h1{
    background-color: transparent;    
    text-align: center;
    border-radius: 10px;
}

.about_paragraphStyle__zFnMX{
    padding: 1em;
    line-height: 2em;
    text-align: justify;
    background-color: transparent;
    border-radius: 10px;
    margin-top: 2em;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    
}

/* second layer css*/

.about_secondLayerContainer__zP7lU{
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin: auto 6em;
    margin-bottom: 2em;
}

.about_innerSecondLayer__8IVCK{
    display: flex;
    gap: 1em;
    display: row;
    justify-content: center;
}

.about_innerSecondLayer__8IVCK div{
    font-size: 1.4em;
    padding: 1em;
    font-weight: bolder;
    flex: 1 1;
    display: flex;
    border-radius: 10px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    justify-content: center;
    background-color: transparent;
    align-items: center;
    height: 3em;
}

/* third layer container */

.about_thirdLayerContainer__h4T7o{
    margin-top: 3em;
    display: flex;
    flex-direction: row;
    gap: 3em;
    margin: auto 6em;
}

.about_thirdLayerContainer__h4T7o div{
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border-radius: 10px;
    background-color: transparent;
    flex: 1 1;
    padding: 1em;
    text-align: center;
}

.about_thirdLayerContainer__h4T7o h2{
    /* font-size: 1em; */
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/core/css/about.module.css"],"names":[],"mappings":";;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,qDAAqD;;AAEzD;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,qDAAqD;IACrD,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;AACf;;AAEA,0BAA0B;;AAE1B;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,mBAAmB;IACnB,6BAA6B;IAC7B,SAAO;IACP,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB","sourcesContent":["\n\n/* upperLayercontainer */\n\n.mainContainer{\n    display: flex;\n    flex-direction: row;\n    padding-top: 7em;\n    gap: 1em;\n    margin: auto 6em;\n}\n\n.leftChildContainer{\n    flex: 1;\n}\n\n.topleftcontainer{\n    display: flex;\n    flex-direction: row;\n}\n\n.topleftcontainer h3{\n    font-size: 1.3em;\n    margin-left: 1em;\n}\n\n.rightChildContainer{\n    flex: 1;\n}\n\n.linkStyle{\n    text-decoration: none;\n    color: black;\n    font-size: 1.3em;\n}\n\n.linkStyle:hover{\n    color: aqua;\n}\n\n.rightChildContainer h1{\n    background-color: transparent;    \n    text-align: center;\n    border-radius: 10px;\n}\n\n.paragraphStyle{\n    padding: 1em;\n    line-height: 2em;\n    text-align: justify;\n    background-color: transparent;\n    border-radius: 10px;\n    margin-top: 2em;\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n    \n}\n\n/* second layer css*/\n\n.secondLayerContainer{\n    display: flex;\n    flex-direction: column;\n    gap: 1em;\n    margin: auto 6em;\n    margin-bottom: 2em;\n}\n\n.innerSecondLayer{\n    display: flex;\n    gap: 1em;\n    display: row;\n    justify-content: center;\n}\n\n.innerSecondLayer div{\n    font-size: 1.4em;\n    padding: 1em;\n    font-weight: bolder;\n    flex: 1;\n    display: flex;\n    border-radius: 10px;\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n    justify-content: center;\n    background-color: transparent;\n    align-items: center;\n    height: 3em;\n}\n\n/* third layer container */\n\n.thirdLayerContainer{\n    margin-top: 3em;\n    display: flex;\n    flex-direction: row;\n    gap: 3em;\n    margin: auto 6em;\n}\n\n.thirdLayerContainer div{\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n    border-radius: 10px;\n    background-color: transparent;\n    flex: 1;\n    padding: 1em;\n    text-align: center;\n}\n\n.thirdLayerContainer h2{\n    /* font-size: 1em; */\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `about_mainContainer__Zl7h9`,
	"leftChildContainer": `about_leftChildContainer__bbIKG`,
	"topleftcontainer": `about_topleftcontainer__0PP1l`,
	"rightChildContainer": `about_rightChildContainer__sNO70`,
	"linkStyle": `about_linkStyle__cxNkj`,
	"paragraphStyle": `about_paragraphStyle__zFnMX`,
	"secondLayerContainer": `about_secondLayerContainer__zP7lU`,
	"innerSecondLayer": `about_innerSecondLayer__8IVCK`,
	"thirdLayerContainer": `about_thirdLayerContainer__h4T7o`
};
export default ___CSS_LOADER_EXPORT___;
